var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"guide"},[_c('div',{staticClass:"parse ql-editor",domProps:{"innerHTML":_vm._s(_vm.content)}}),_c('div',{staticClass:"btn",on:{"click":_vm.toContract}},[_vm._v("同意")])])
}
var staticRenderFns = []

export { render, staticRenderFns }